import { gql } from "@apollo/client";

export const GENERATE_EVIDENCE_DOWNLOAD_SIGNED_URL = gql`
  mutation GenerateEvidenceDownloadSignedUrl(
    $evidence_ids: [Int]
    $evidence_type: String
  ) {
    generateEvidenceDownloadSignedUrl(
      evidence_ids: $evidence_ids
      evidence_type: $evidence_type
    ) {
      url
    }
  }
`;

export const EXPORT_CONTROLS_EVIDENCE = gql`
  mutation ExportControlsEvidence(
    $controlIds: [Int!]!
    $auditId: ID!
    $end_time: DateTime
  ) {
    exportControlsEvidence(
      controlIds: $controlIds
      audit_id: $auditId
      end_time: $end_time
    ) {
      success
      message
      data {
        downloadUrl
        fileName
        expiresIn
      }
    }
  }
`;

export const EXPORT_CONTROL_EVIDENCE = gql`
  mutation ExportControlEvidence(
    $controlId: Int!
    $auditId: ID!
    $end_time: DateTime
  ) {
    exportControlEvidence(
      controlId: $controlId
      audit_id: $auditId
      end_time: $end_time
    ) {
      success
      message
      data {
        downloadUrl
        fileName
        expiresIn
      }
    }
  }
`;
